import * as THREE from "three";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader.js";
import fragment from "./shader/fragment.glsl";
import fragmentNoise from "./shader/fragmentNoise.glsl";
import vertex from "./shader/vertex.glsl";

import GUI from "lil-gui";
import gsap from "gsap";
const createInputEvents = require("simple-input-events");
import bg from "../../img/bg.png";
import noise from "../../img/noise.png";
import { Text, preloadFont } from "troika-three-text";

import lavafragment from "./shader/lava-fragment.glsl";
import lavavertex from "./shader/lava-vertex.glsl";

function lerp(a, b, n) {
  return (1 - n) * a + n * b;
}

function r(a, b) {
  return lerp(a, b, Math.random());
}

const PALLETTE = [
  new THREE.Color(0.109, 0.673, 0.782),
  new THREE.Color(0.063, 0.191, 0.501),
  new THREE.Color(0.109, 0.274, 0.733),
  new THREE.Color(0.077, 0.191, 0.563),
  new THREE.Color(0.091, 0.187, 0.554),
];

export default class Sketch {
  constructor(options) {
    this.scene = new THREE.Scene();
    this.sceneNoise = new THREE.Scene();

    this.container = options.dom;
    this.width = this.container.offsetWidth;
    this.height = this.container.offsetHeight;
    this.renderer = new THREE.WebGLRenderer({
      transparent: true,
      alpha: true,
      antialias: true,
    });

    this.renderer.autoClear = false;

    this.renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    this.renderer.setSize(this.width, this.height);
    this.renderer.setClearColor(0xeeeeee, 1);
    this.renderer.physicallyCorrectLights = true;
    this.renderer.outputEncoding = THREE.sRGBEncoding;
    this.event = createInputEvents(this.renderer.domElement);

    this.container.appendChild(this.renderer.domElement);

    this.camera = new THREE.PerspectiveCamera(
      50,
      this.width / this.height,
      0.01,
      100
    );

    this.scroll = 0;
    this.speed = 0;

    // var frustumSize = 10;
    // var aspect = window.innerWidth / window.innerHeight;
    // this.camera = new THREE.OrthographicCamera( frustumSize * aspect / - 2, frustumSize * aspect / 2, frustumSize / 2, frustumSize / - 2, -1000, 1000 );
    this.camera.position.set(0, 0, 1.3);
    // this.controls = new OrbitControls(this.camera, this.renderer.domElement);
    this.time = 0;

    this.dracoLoader = new DRACOLoader();
    this.dracoLoader.setDecoderPath(
      "https://raw.githubusercontent.com/mrdoob/three.js/dev/examples/js/libs/draco/"
    ); // use a full url path
    this.gltf = new GLTFLoader();
    this.gltf.setDRACOLoader(this.dracoLoader);

    this.mouse = new THREE.Vector2(0, 0);
    this.settings();
    this.events();
    // this.addObjects()
    this.addMiya();
    // this.addNoise()

    this.render();

    this.setupResize();

    // this.renderer.compile(this.scene, this.camera)
    // this.renderer.compile(this.sceneAbout, this.cameraAbout)

    if (document.body.classList.contains("body-index")) {
      gsap.timeline({
        onUpdate: (args) => {
          // this.progress = this.animation.progress();
          console.log(args);

          // if(!this.play) {
          //     this.play = true;this.render();
          // } else{
          //     this.play = false;
          // }
        },
        scrollTrigger: {
          scroller: ".scrollContainer",
          scrub: true,
          trigger: "#bluebackground",
          pin: true,
          anticipatePin: 1,
          onEnterBack: () => {
            // if(!this.play) this.play = true;this.render();
          },
          onEnter: () => {
            // if(!this.play) this.play = true;this.render();
          },
          onLeave: () => {
            // this.play = false
          },
          onLeaveBack: () => {
            // this.play = false
          },
          start: "top top",
          //   end: pinWrapWidth
          end: "bottom bottom-=" + 2 * this.height + "px",
        },
      });
    }
  }
  events() {
    this.event.on("move", ({ uv }) => {
      this.mouse.x = -(uv[0] - 0.5) * 0.2;
      this.mouse.y = -(uv[1] - 0.5) * 0.2;
    });
  }

  settings() {
    let that = this;
    this.settings = {
      uColor1: PALLETTE[0].getHexString(),
      uColor2: PALLETTE[1].getHexString(),
      uColor3: PALLETTE[2].getHexString(),
      uColor4: PALLETTE[3].getHexString(),
      uColor5: PALLETTE[4].getHexString(),
      uRotation: 0.55,
      uRange1: 0.5,
      uRange2: 0.1,
      uScale1: 1,
      uScale2: 1,
      uAmp: 0.1,
      uNoise: 0.05,
      uNoiseSize: 2,
      uSpeed: 5,
    };
    // this.gui = new GUI();
    // this.gui.addColor(this.settings, "uColor1").onChange(()=>{
    //   this.material.uniforms.uColor1.value = new THREE.Color(this.settings.uColor1)
    // })
    // this.gui.addColor(this.settings, "uColor2").onChange(()=>{
    //   this.material.uniforms.uColor2.value = new THREE.Color(this.settings.uColor2)
    // });
    // this.gui.addColor(this.settings, "uColor3").onChange(()=>{
    //   this.material.uniforms.uColor3.value = new THREE.Color(this.settings.uColor3)
    // });
    // this.gui.addColor(this.settings, "uColor1").onChange((val)=>{
    //   this.m.uniforms.uColor1.value = new THREE.Color(val)
    // })

    // this.gui.addColor(this.settings, "uColor2").onChange((val)=>{
    //   this.m.uniforms.uColor2.value = new THREE.Color(val)
    // })

    // this.gui.addColor(this.settings, "uColor3").onChange((val)=>{
    //   this.m.uniforms.uColor3.value = new THREE.Color(val)
    // })

    // this.gui.addColor(this.settings, "uColor4").onChange((val)=>{
    //   this.m.uniforms.uColor4.value = new THREE.Color(val)
    // })

    // this.gui.addColor(this.settings, "uColor5").onChange((val)=>{
    //   this.m.uniforms.uColor5.value = new THREE.Color(val)
    // })

    // this.gui.add(this.settings, "uNoise", 0, 1, 0.01).onChange((val)=>{
    //   this.materialNoise.uniforms.uNoise.value = val
    // })
    // this.gui.add(this.settings, "uNoiseSize", 0, 4, 0.01).onChange((val)=>{
    //   this.materialNoise.uniforms.uNoiseSize.value = val
    // })
    // this.gui.add(this.settings, "uRotation", 0, 3, 0.01).onChange((val)=>{
    //   // this.material.uniforms.uRotation.value = val
    //   this.m.uniforms.uRotation.value = val
    //   this.mesh.rotation.z = -val;
    // })

    // this.gui.add(this.settings, "uSpeed", 0.1, 5, 0.01).onChange((val)=>{
    //   this.m.uniforms.uSpeed.value = val
    // })
    // this.gui.add(this.settings, "uAmp", 0., 0.3, 0.01).onChange((val)=>{
    //   this.m.uniforms.uAmp.value = val
    // })

    // this.gui.add(this.settings, "uRange1", 0, 1, 0.01).onChange(()=>{
    //   this.material.uniforms.uRange1.value = this.settings.uRange1
    // })
    // this.gui.add(this.settings, "uRange2", 0, 1, 0.01).onChange(()=>{
    //   this.material.uniforms.uRange2.value = this.settings.uRange2
    // })
    // this.gui.add(this.settings, "uScale1", 0, 3, 0.01).onChange(()=>{
    //   this.material.uniforms.uScale1.value = this.settings.uScale1
    // })

    // this.gui.add(this.settings, "uScale2", 0, 3, 0.01).onChange(()=>{
    //   this.material.uniforms.uScale2.value = this.settings.uScale2
    // })
  }

  setupResize() {
    window.addEventListener("resize", this.resize.bind(this));
  }

  resize() {
    this.width = window.innerWidth;
    this.height = window.innerHeight;
    this.renderer.setSize(this.width, this.height);
    this.camera.aspect = this.width / this.height;
    this.camera.updateProjectionMatrix();
  }

  addMiya() {
    this.m = new THREE.ShaderMaterial({
      extensions: {
        derivatives: "#extension GL_OES_standard_derivatives : enable",
      },
      side: THREE.DoubleSide,
      uniforms: {
        uSpeed: { value: 5 },
        uAmp: { value: 0.1 },
        uRotation: { value: 0.55 },
        uColor1: { value: PALLETTE[0] },
        uColor2: { value: PALLETTE[1] },
        uColor3: { value: PALLETTE[2] },
        uColor4: { value: PALLETTE[3] },
        uColor5: { value: PALLETTE[4] },
        time: { value: 0 },
        resolution: {
          value: new THREE.Vector2(window.innerWidth, window.innerHeight),
        },
      },
      // wireframe: true,
      // transparent: true,
      vertexShader: lavavertex,
      fragmentShader: lavafragment,
    });

    let geo = new THREE.PlaneGeometry(1.3, 1.3, 200, 200);

    this.mesh = new THREE.Mesh(geo, this.m);
    this.mesh.position.z = 1;
    this.mesh.position.y = 0.1;
    this.mesh.rotation.z = -0.55;
    this.mesh.position.x = 0.1;
    this.scene.add(this.mesh);
  }

  addObjects() {
    let that = this;
    this.material = new THREE.ShaderMaterial({
      extensions: {
        derivatives: "#extension GL_OES_standard_derivatives : enable",
      },
      side: THREE.DoubleSide,
      uniforms: {
        time: { value: 0 },
        texture1: { value: new THREE.TextureLoader().load(bg) },
        uColor1: { value: new THREE.Color(this.settings.uColor1) },
        uColor2: { value: new THREE.Color(this.settings.uColor2) },
        uColor3: { value: new THREE.Color(this.settings.uColor3) },
        uRange1: { value: 0.5 },
        uRange2: { value: 0.1 },
        uScale1: { value: 1 },
        uRotation: { value: 0.55 },
        uNoise: { value: 0.1 },
        uScale2: { value: 1 },
        resolution: {
          value: new THREE.Vector4(),
        },
      },
      // wireframe: true,
      // transparent: true,
      vertexShader: vertex,
      fragmentShader: fragment,
    });

    this.geometry = new THREE.SphereGeometry(1.5, 32, 32);

    this.plane = new THREE.Mesh(this.geometry, this.material);
    this.scene.add(this.plane);
  }

  addNoise() {
    let that = this;
    this.materialNoise = new THREE.ShaderMaterial({
      side: THREE.DoubleSide,
      uniforms: {
        time: { value: 0 },

        ratio: { value: window.devicePixelRatio },
        uNoiseTexture: { value: new THREE.TextureLoader().load(noise) },
        uNoise: { value: 0.05 },
        uNoiseSize: { value: 2 },
        resolution: {
          value: new THREE.Vector4(this.width, this.height),
        },
      },
      // wireframe: true,
      transparent: true,
      vertexShader: vertex,
      fragmentShader: fragmentNoise,
      // blending: THREE.AdditiveBlending
    });

    this.geometry = new THREE.PlaneGeometry(3, 3);

    this.noise = new THREE.Mesh(this.geometry, this.materialNoise);
    this.sceneNoise.add(this.noise);
    this.noise.position.z = 1.1;
  }

  stop() {
    this.isPlaying = false;
  }

  play() {
    if (!this.isPlaying) {
      this.isPlaying = true;
      this.render();
    }
  }

  render() {
    // console.log('blue play')
    // if (!this.isPlaying) return;
    this.time += 0.05;
    if (this.material) this.material.uniforms.time.value = this.time / 10;
    if (this.m) this.m.uniforms.time.value = this.time * 0.001;
    if (this.materialNoise)
      this.materialNoise.uniforms.time.value = this.time / 10;
    this.renderer.render(this.scene, this.camera);
    this.renderer.render(this.sceneNoise, this.camera);

    requestAnimationFrame(this.render.bind(this));
  }
}
